export const wallpaperURL =
  "https://res.cloudinary.com/dixrgy8ki/image/upload/v1616589315/wallpapers/andy-holmes-rCbdp8VCYhQ-unsplash_v7saxz.jpg";
export const profileImgURL =
  "https://res.cloudinary.com/dixrgy8ki/image/upload/v1605477659/wallpapers/profile_guqpg6.jpg";
